export class WorkloadInvestigationEntity {
  public investigationId!: string;
  public investigationNumber!: string;
  public investigationTypeName!: string;
  public overdueText!: string;
  public overdueDays!: number;
  public status!: string;
  public detailUrl!: string;

  public investigationTypeId?: string;
  public statusId?: string;
  public statusName?: string;
  public priorityCode?: string;
  public dueDate?: string | null;
  public isOverdue?: boolean;
  public isAtRisk?: boolean;
  public isClosed?: boolean;
}
